(function ($) {
    $(function () {

        $('.hamburger').click(function () {
            $("body").toggleClass("navShown");
            $(".nav-wrap").fadeToggle()
        });


        // Contact page function
        if ($("select.styled-select").length) {
            $("select.styled-select").selectric({});
        }

        // marquee-slider
        $('.marquee-slider-wrap').marquee({
            direction: 'left',
            duration: 50000,
            gap: 50,
            delayBeforeStart: 0,
            duplicated: true,
            startVisible: true
        });


        if ($('.videos-item-wrap').length) {
            $('.videos-item-wrap').slick({
                autoplay: false,
                autoplaySpeed: 1500,
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            adaptiveHeight: true,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                        },
                    },
                ],
            });
        }

        if ($('.backed-puffs-wrap').length) {

          if($(window).width() > 768){
            // var swiper = new Swiper(".mySwiper", {
            //     loop: true,
            //     spaceBetween: 0,
            //     slidesPerView: 1,
            //     watchSlidesProgress: true,
            //     allowTouchMove: false,
            // });
            // var swiper2 = new Swiper(".mySwiper2", {
            //     slidesPerView: "auto",
            //     spaceBetween: 0,
            //     centeredSlides: true,
            //     loop: true,
            //     allowTouchMove: false,
            //     navigation: {
            //         nextEl: ".cheez-arrow-next",
            //         prevEl: ".cheez-arrow-prev",
            //     },
            //     thumbs: {
            //         swiper: swiper,
            //     },
            // });

            $('.cheez-slider-item-wrap').slick({
              slidesToShow: 5,
              slidesToScroll: 1,
              arrows: true,
              centerMode: true,
              infinite: true,
              speed: 400,
             centerPadding: '0',
              asNavFor: '.backed-puffs-item-wrap',
              prevArrow: $('.cheez-arrow-prev'),
              nextArrow: $('.cheez-arrow-next'),
            });
            $('.backed-puffs-item-wrap').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              asNavFor: '.cheez-slider-item-wrap',
              dots: false,
              focusOnSelect: false
            });
            $('.cheez-slider-item.slick-current.slick-center').prev().addClass('slick-prev-slide')
            $('.cheez-slider-item.slick-current.slick-center').next().addClass('slick-next-slide')
            $('.cheez-slider-item.slick-current.slick-center').addClass('slick-slide-current')
            $('.cheez-slider-item-wrap').on('afterChange', function(){
    
            $('.cheez-slider-item').removeClass('slick-prev-slide')
            $('.cheez-slider-item').removeClass('slick-next-slide')
            $('.cheez-slider-item').removeClass('slick-slide-current')
            $('.cheez-slider-item.slick-current.slick-center').prev().addClass('slick-prev-slide')
            $('.cheez-slider-item.slick-current.slick-center').next().addClass('slick-next-slide')
            $('.cheez-slider-item.slick-current.slick-center').addClass('slick-slide-current')
});
            
            
          }
          if($(window).width() < 769){
            $('.cheez-slider-item-wrap').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              asNavFor: '.backed-puffs-item-wrap',
              prevArrow: $('.cheez-arrow-prev'),
              nextArrow: $('.cheez-arrow-next'),
            });
            $('.backed-puffs-item-wrap').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              asNavFor: '.cheez-slider-item-wrap',
              dots: false,
              focusOnSelect: false
            });
          }
        }
    }) // End ready function.

})(jQuery)


function increaseCount(e, el) {
    var input = el.previousElementSibling;
    var value = parseInt(input.value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    input.value = value;
}

function decreaseCount(e, el) {
    var input = el.nextElementSibling;
    var value = parseInt(input.value, 10);
    if (value > 1) {
        value = isNaN(value) ? 0 : value;
        value--;
        input.value = value;
    }
}